"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Seat = void 0;
const common_1 = require("../../common");
const models_1 = require("../../setup/models");
const employee_model_1 = require("./employee.model");
class Seat extends common_1.MongoDocument {
}
exports.Seat = Seat;
//# sourceMappingURL=seat.model.js.map